import { Modelo } from '@ext/index';
import * as Types from './RespuestaPredefinida.types';
import moment, { Moment } from 'moment';

export class IRespuestaPredefinida extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Estado: string = 'activo';
    public Titulo: string = '';
    public Respuesta: string = '';
    public Tags: string = '';
    public Color: string = '';


    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.estado = this.Estado;
        json.titulo = this.Titulo;
        json.respuesta = this.Respuesta;
        json.tags = this.Tags;
        json.color = this.Color;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Estado = !this.Json.estado ? '' : this.Json.estado;
        this.Titulo = !this.Json.titulo ? '' : this.Json.titulo;
        this.Respuesta = !this.Json.respuesta ? '' : this.Json.respuesta;
        this.Tags = !this.Json.tags ? '' : this.Json.tags;
        this.Color = !this.Json.color ? '' : this.Json.color;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IRespuestaPredefinida )
    {
        this.Model = Model;
    }

    public Model: IRespuestaPredefinida;
}